"use client";

import { getUserData } from "@/actions/serverActions/getUserDataAction";
import { NavItem } from "@/actions/ssr/nav-management/navDataSSR";
import logo from "@/assets/logos/LOGO-OR.png";
import { NavMain } from "@/components/Nav/nav-main";
import { NavSecondary } from "@/components/Nav/nav-secondary";
import { NavUser } from "@/components/Nav/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { APP_VERSION, APP_VERSION_NAME } from "@/config";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";

interface AppSidebarProps {
  variant: "inset" | "sidebar" | "floating" | undefined;
  navData: NavItem[];
}

export function AppSidebar({ variant, navData }: AppSidebarProps) {
  const [userData, setUserData] = useState<any>(null);

  useEffect(() => {
    getUserData().then((data) => {
      setUserData(data);
    });
  }, []);

  const data = {
    user: {
      name: userData?.full_name || "Cashless AI",
      email: userData?.email || "cashless@gmail.com",
      avatar: userData?.profile_image_url,
    },
    navMain: [] as NavItem[],

    navSecondary: [
      {
        title: "Profile",
        url: "#",
        icon: "IconUser",
      },
      {
        title: "Get Help",
        url: "#",
        icon: "IconHelp",
      },
      {
        title: "Settings",
        url: "/settings",
        icon: "IconSettings",
      },
    ],
  };
  // Merge fetched navData into the static data structure
  data.navMain = navData.length && navData ? navData : [];

  return (
    <Sidebar collapsible="offcanvas" variant={variant}>
      <SidebarHeader className="p-0">
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              className="data-[slot=sidebar-menu-button]:h-auto data-[slot=sidebar-menu-button]:p-0 hover:bg-transparent focus:bg-transparent active:bg-transparent"
            >
              <Link href="/" className="block w-full px-3 py-1">
                <div className="flex flex-col">
                  <div className="relative -my-2">
                    <Image
                      src={logo}
                      alt="Cashless AI Logo"
                      width={200}
                      height={67}
                      className="w-full h-auto object-contain"
                      priority
                    />
                  </div>
                  <div className="flex justify-end -mt-3">
                    <span className="text-[11px] font-medium italic text-muted-foreground/70">
                      {APP_VERSION_NAME} v{APP_VERSION}
                    </span>
                  </div>
                </div>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} userAccountType={userData?.account_type} />
        {/* <NavDocuments items={data.documents} /> */}
        <NavSecondary items={data.navSecondary} className="mt-auto" />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={data.user} />
      </SidebarFooter>
    </Sidebar>
  );
}
